import {CanDeactivateFn} from '@angular/router';
import {Observable, of, switchMap} from 'rxjs';
import {inject} from '@angular/core';
import {AUTHENTICATION_TOKEN} from '~shared/ng/tokens/shared-tokens';
import {AuthenticationServiceBase} from '~shared/types/authentication.types';


export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const unsavedConfirmGuard: CanDeactivateFn<CanComponentDeactivate> = (component: CanComponentDeactivate) => {
    const authenticationService: AuthenticationServiceBase = inject(AUTHENTICATION_TOKEN)

    return authenticationService.isAuthorized$.pipe(
        switchMap(($isAuthorized) => {
            if ($isAuthorized && component.canDeactivate) {
                const result = component.canDeactivate();
                if (typeof result === 'boolean') {
                    return of(result);
                } else {
                    return result;
                }
            }
            return of(true)
        })
    );
};
